import styled from 'styled-components';

type NoEdgeProps = {
  labelX: number;
  labelY: number;
};

export const StyledEdge = styled.div<NoEdgeProps>`
  position: absolute;
  transform: translate(-50%, -50%) translate(${({ labelX }) => labelX}px, ${({ labelY }) => labelY}px);
  background: var(--color-gray-20);
  padding: 10px;
  border-radius: 5px;
  user-select: none;
  cursor: pointer;
  pointer-events: all;

  font: var(--font-extra-small-12pt-normal);
`;
